/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the before day settings
 * @export
 * @interface CancelHourRequest
 */
export interface CancelHourRequest {
    /**
     * the number of hour before an appointment can be cancelled
     * @type {number}
     * @memberof CancelHourRequest
     */
    cancelHour?: number;
}

/**
 * Check if a given object implements the CancelHourRequest interface.
 */
export function instanceOfCancelHourRequest(value: object): value is CancelHourRequest {
    return true;
}

export function CancelHourRequestFromJSON(json: any): CancelHourRequest {
    return CancelHourRequestFromJSONTyped(json, false);
}

export function CancelHourRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelHourRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cancelHour': json['cancelHour'] == null ? undefined : json['cancelHour'],
    };
}

export function CancelHourRequestToJSON(json: any): CancelHourRequest {
    return CancelHourRequestToJSONTyped(json, false);
}

export function CancelHourRequestToJSONTyped(value?: CancelHourRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cancelHour': value['cancelHour'],
    };
}

